 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"210bdf8c","1":"commons","6":"component---src-pages-404-js","7":"component---src-pages-accessibility-overview-mdx","8":"component---src-pages-components-accordion-mdx","9":"component---src-pages-components-avatars-mdx","10":"component---src-pages-components-badge-mdx","11":"component---src-pages-components-breadcrumb-mdx","12":"component---src-pages-components-bubble-chat-mdx","13":"component---src-pages-components-buttons-mdx","14":"component---src-pages-components-calendar-mdx","15":"component---src-pages-components-card-mdx","16":"component---src-pages-components-carousel-mdx","17":"component---src-pages-components-chat-box-mdx","18":"component---src-pages-components-composer-mdx","19":"component---src-pages-components-dropdown-mdx","20":"component---src-pages-components-empty-state-mdx","21":"component---src-pages-components-file-attachment-mdx","22":"component---src-pages-components-form-check-mdx","23":"component---src-pages-components-form-input-mdx","24":"component---src-pages-components-header-mdx","25":"component---src-pages-components-icon-mdx","26":"component---src-pages-components-loader-mdx","27":"component---src-pages-components-logo-mdx","28":"component---src-pages-components-media-mdx","29":"component---src-pages-components-message-mdx","30":"component---src-pages-components-modal-mdx","31":"component---src-pages-components-multi-steps-mdx","32":"component---src-pages-components-overlay-mdx","33":"component---src-pages-components-pagination-mdx","34":"component---src-pages-components-progress-mdx","35":"component---src-pages-components-rating-mdx","36":"component---src-pages-components-search-box-mdx","37":"component---src-pages-components-separator-mdx","38":"component---src-pages-components-sidebar-menu-mdx","39":"component---src-pages-components-skeleton-mdx","40":"component---src-pages-components-slider-mdx","41":"component---src-pages-components-tab-mdx","42":"component---src-pages-components-tag-input-mdx","43":"component---src-pages-components-tag-mdx","44":"component---src-pages-components-toast-mdx","45":"component---src-pages-components-toggle-mdx","46":"component---src-pages-components-top-banner-mdx","47":"component---src-pages-components-top-menu-mdx","48":"component---src-pages-css-utilities-animation-mdx","49":"component---src-pages-css-utilities-borders-mdx","50":"component---src-pages-css-utilities-box-shadow-mdx","51":"component---src-pages-css-utilities-colors-mdx","52":"component---src-pages-css-utilities-cursors-mdx","53":"component---src-pages-css-utilities-display-mdx","54":"component---src-pages-css-utilities-filters-mdx","55":"component---src-pages-css-utilities-object-fit-mdx","56":"component---src-pages-css-utilities-opacities-mdx","57":"component---src-pages-css-utilities-position-mdx","58":"component---src-pages-css-utilities-spacing-mdx","59":"component---src-pages-css-utilities-svg-mdx","60":"component---src-pages-css-utilities-text-mdx","61":"component---src-pages-css-utilities-user-select-mdx","62":"component---src-pages-foundations-colors-mdx","63":"component---src-pages-foundations-illustration-mdx","64":"component---src-pages-getting-started-introduction-mdx","65":"component---src-pages-index-js","66":"component---src-pages-layout-block-layout-mdx","67":"component---src-pages-layout-flex-box-mdx","68":"component---src-pages-layout-grid-mdx","69":"component---src-pages-layout-list-mdx","70":"component---src-pages-layout-page-layout-mdx","71":"component---src-pages-layout-split-pane-mdx","72":"component---src-pages-layout-table-mdx","73":"component---src-pages-release-notes-mdx"}[chunkId]||chunkId) + "-" + {"0":"e75787f049633653af33","1":"2048498206c64169ba07","3":"9096c1143298fa4248ae","6":"db9d8313e1d8fba9767a","7":"7217c7434c44714a35f9","8":"3f309c9eb78d20ed7cb7","9":"4b74cdbe28b751f57662","10":"930ab8afb21db945eb6e","11":"4fd56a8fa1c87e20a488","12":"f3914b641b702a22a496","13":"31e54449668cf2a61f09","14":"c46d2163bd8b84bd07e9","15":"94b76474c952af6939f1","16":"6915a70111a7d41f9176","17":"c0e8c4ade4366829f8d2","18":"49685c681e7258cf8952","19":"acf0484a8bf70017cf42","20":"fe9e6e08fad31372c148","21":"af976ae67f6ad21fc11a","22":"3d290116a5d8b5a275f1","23":"c532b9eac946042df88a","24":"9e0197eff72d2cf76ce4","25":"7c77a84f6dadfc9ea3d9","26":"9628b5f2414c7dec111b","27":"91d73dafa64687fcf674","28":"74635e53ca48ef2bca43","29":"0150f8aceb77a3fcfce8","30":"80b773536c8407f6266e","31":"68af1fbdd493764a04aa","32":"13dbd64c542cbe0fbd69","33":"d7aeaa0fd33617488a6f","34":"38b1e62a541fc739f3bb","35":"8512dbacf16042930648","36":"3df3d17a8b3dd15cfa5e","37":"c192103dcf6be74b834d","38":"c5500ee7eae9fe463b0d","39":"3e8b304d234d09d678e5","40":"d516c6f9146edf4f509c","41":"2c94512af72fdc781c7d","42":"14172285db08f7725cf5","43":"a8f9d1d5cac35ccd8a9f","44":"ba57f1fcfbc2d7738355","45":"77621c7f87847c1ffb6a","46":"d05a23bf5fecb7bb6e41","47":"d012545b5b862896c76d","48":"36a39bac85212a62c656","49":"62804a1f1f868838a041","50":"6ab8d60b49d72c1c92cc","51":"16f467b8fb5684bb0850","52":"3275bb59eda6d0c459a0","53":"f9e034be64a950a664f0","54":"bd5bce162da80f2daec7","55":"534f2e563c585a6acca0","56":"44fcd8d64ffdb1f3048b","57":"2670a33a143f53ce36b2","58":"e8a81dfc8936aef75845","59":"d0500ca1415a8b1f05fb","60":"0256114a315f1f173ad0","61":"edc28fb7f435fb4e2cef","62":"82e37331ba01d92d488b","63":"8b598447f53b22b2fd5d","64":"f47840a4f1acbfcfebc8","65":"9ec23171293d02312e42","66":"1897e01c5164e36c4e8b","67":"2cb6267a8c1bca5e5a12","68":"6d5ab25f6ba3fe19f676","69":"9d10b011d2e71baf925b","70":"44f17af4fb48ae0dacef","71":"48f3d1db345799a36d2d","72":"577f33d32c0753f741cf","73":"e53f413d84163347abd6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/2/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
